<template>
        <div v-for="col in meta.columns" :key="col">
          <base-geo-cell v-bind="{mode:'edit', column:col, initValue:curentRow[col.fieldname], meta:meta, rowobject:curentRow}" v-model="curentRow[col.fieldname]"/>
        </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'DefaultBaseFormT',
    components: {

},

data(){ 
    return {
      dialogedecology: false,

    }
},
props:['meta', 'curentRow', 'modelValue'],
emits: ['update:modelValue'],
methods: {

},

  mounted(){

  },

})
</script>